import React from 'react';
import { RiCloseLine } from 'react-icons/ri';
import * as translator from '../../../../utils/translator';

interface UnknownStockConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  pharmacyName: string;
  pharmacyAddress: string;
}

export const UnknownStockConfirmationModal: React.FC<UnknownStockConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  pharmacyName,
  pharmacyAddress,
}) => {
  const language = localStorage.getItem('language') || 'de';

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.72)' }}
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden">
        {/* Header with orange background */}
        <div className="relative flex items-center gap-2 px-6 py-3" style={{ backgroundColor: 'rgba(240, 142, 0, 0.1)' }}>
          <img src="/unKnownstockVector.png" alt={translator.translate(language, 'choose_treatment', 'unknown_stock_modal/title')} className="w-5 h-5" />
          <span className="text-base font-semibold" style={{ color: '#F08E00' }}>{translator.translate(language, 'choose_treatment', 'unknown_stock_modal/title')}</span>
          
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-3 right-4 flex items-center justify-center w-6 h-6 cursor-pointer border-none bg-transparent hover:opacity-70 transition-opacity"
            aria-label="Close"
          >
            <RiCloseLine className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 pb-6 pt-4 space-y-4">
          <p className="text-[14px] text-black font-poppins font-medium leading-relaxed">
            {translator.translate(language, 'choose_treatment', 'unknown_stock_modal/selected_pharmacy_intro')}
          </p>

          {/* Pharmacy info */}
          <div className="space-y-1">
            <h3
              className="font-semibold font-poppins text-[16px]"
              style={{ color: '#818181' }}
            >
              {pharmacyName}
            </h3>
            <p
              className="text-[12px] font-poppins font-normal"
              style={{ color: '#818181' }}
            >
              {pharmacyAddress}
            </p>
          </div>

          {/* Warning message */}
          <p className="text-[14px] font-poppins font-medium"
             style={{ color: '#BFBFBF' }}
          >
            {translator.translate(language, 'choose_treatment', 'unknown_stock_modal/warning')}
          </p>

          {/* Confirmation question */}
          <p className="text-[14px] font-medium font-poppins text-black">
            {translator.translate(language, 'choose_treatment', 'unknown_stock_modal/confirm_question')}
          </p>

          {/* Action buttons */}
          <div className="flex gap-3 mt-6">
            <button
              onClick={onConfirm}
              className="flex-1 px-6 py-3 rounded-lg text-white text-[16px] font-poppins font-bold border-none cursor-pointer transition-all hover:brightness-95"
              style={{ backgroundColor: '#06D1A1' }}
            >
              {translator.translate(language, 'choose_treatment', 'unknown_stock_modal/confirm_button')}
            </button>
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 rounded-lg text-[16px] font-bold font-poppins cursor-pointer transition-all hover:bg-gray-50"
              style={{ 
                border: '2px solid #11DDAC',
                color: '#06D1A1',
                backgroundColor: 'white'
              }}
            >
              {translator.translate(language, 'choose_treatment', 'unknown_stock_modal/cancel_button')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
